import { render } from "./Call.vue?vue&type=template&id=3c02acac"
import script from "./Call.vue?vue&type=script&lang=js"
export * from "./Call.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__